// src/mocks/companyProfile.ts
import type { CompanyProfile } from "@/types/company";

export const mockCompanyProfile: CompanyProfile[] = [
    {
    // Profile information
    psNumber: "7903",
    companyName: "PS in Foodservice B.V.",
    glnNumber: "8712345678900",
    generalEmail: "info@psinfoodservice.com",
    productEmail: "producten@psinfoodservice.com",
    website: "https://psinfoodservice.com",
    phone: "+31 20 1234567",
    description: "De grootste zoekmachine van de foodservice markt. Vind, beheer en deel eenvoudig complete productinformatie over eten, drinken en non-food voor de hele keten.",
    logo: "/logo.png",

    // Address information
    address: {
        street: "Nieuwe Kazernelaan 2-D41-A12",
        postalCode: "6711 JC",
        city: "Ede",
        country: "Nederland"
    },

    // Subscription information
    subscription: {
        type: "premium+",
        startDate: "2024-01-01",
            extraServices: "Extra services:\n- 24/7 support\n- Maatwerk oplossingen"
        }
    }
]; 